import moment from 'moment';
import _ from 'lodash';
import { AsYouType } from 'libphonenumber-js';

export function formatBirthDate(date) {
  if (!date) {
    return 'N/A';
  }
  return moment(date).format('YYYY-MM-DD');
}

export function formatPhoneNumber(number) {
  if (number) {
    const asYouType = new AsYouType('US');
    return asYouType.input(number);
  }
  return '';
}

export function findNext(base, index, validator) {
  if (index >= base.length || index < 0 || base.length === 0) return null;

  let subset;
  // if not last index
  if (index !== base.length - 1) {
    // bring up next incomplete activity
    subset = _.slice(base, index + 1, base.length);
    const item = _.find(subset, validator);
    if (item) return item;
  }

  // bring up first incomplete activity
  subset = _.slice(base, 0, index);
  const item = _.find(subset, validator);
  if (item) return item;

  return null;
}

export function formatEmbeddedYoutube(content) {
  return content ? content.replace(
    / src="https:\/\/www\.youtube\.com\/embed\//g,
    ' allowFullScreen="allowFullScreen"  src="https://www.youtube.com/embed/',
  ) : '';
}

export function arrayWithoutElementAtIndex(arr, index) {
  return arr.filter((value, arrIndex) => index !== arrIndex);
}

export function checkHasStarted(questionIndexInt, questionsCompleted, questionsObject) {
  const currentQuestion = _.find(questionsObject, { index: questionIndexInt });
  const otherQuestionsCompleted = arrayWithoutElementAtIndex(questionsCompleted, questionIndexInt).filter(Boolean).length > 0;

  if (otherQuestionsCompleted) {
    return true;
  } else if (typeof currentQuestion !== 'undefined' && !_.isEmpty(currentQuestion.answer)) {
    if (currentQuestion.answer.value === 0 || currentQuestion.answer.value === '') {
      return false;
    }
    return true;
  }
  return false;
}

export function fieldHasErrors(errors, key) {
  const currentErrors = _.groupBy(errors, error => error.path[1]);
  return !_.isEmpty(currentErrors[key]);
}

export function fieldErrorText(errors, key) {
  if (fieldHasErrors(errors, key)) {
    const currentErrors = _.groupBy(errors, error => error.path[1]);
    return currentErrors[key][0].message;
  }
  return '';
}

export function getBasePath(pathname) {
  const paths = pathname.split('/');
  if (paths !== null) {
    return `/${paths[1]}`;
  }
  return '';
}
